import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteCarteiraPreBaixar } from '../cliente-carteira-prebaixar';
import { ClienteCarteiraPreBaixado } from '../cliente-carteira-prebaixado';
import { ClienteCarteiraPreBaixaCancelada } from '../cliente-carteira-prebaixa-cancelada';

@Injectable({
    providedIn: 'root'
})
export class ClienteCarteiraPreBaixarHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clientecarteira`;
    }

    /** Carrega os dados da pré-baixa do do cliente pré-baixado informado */
    loadPreBaixa(idCliente: number): Observable<ClienteCarteiraPreBaixado> {
        return this.customHttp.get<ClienteCarteiraPreBaixado>(`${this.pathApi}/0/prebaixa/${idCliente}`);
    }

    /** Realiza a pré-baixa do cliente informado */
    preBaixar(entityPreBaixa: ClienteCarteiraPreBaixar): Observable<ClienteCarteiraPreBaixado> {
        return this.customHttp.put<ClienteCarteiraPreBaixado>(`${this.pathApi}/0/prebaixa/${entityPreBaixa?.idCliente}`, entityPreBaixa);
    }

    /** Realiza o cancelamento da pré-baixa do cliente informado */
    cancelarPreBaixa(idCliente: number): Observable<ClienteCarteiraPreBaixaCancelada> {
        return this.customHttp.put<ClienteCarteiraPreBaixaCancelada>(`${this.pathApi}/0/prebaixa/${idCliente}/cancelar`, null);
    }
}
